export { default } from './category-page-loading-state';
